export const slicingWord = (sentence, maxCharacters) => {
  if (sentence.length <= maxCharacters) {
    return sentence;
  }

  let slicingWord = sentence.substr(0, maxCharacters);
  let lastSpaceIndex = slicingWord.lastIndexOf(" ");

  if (lastSpaceIndex !== -1) {
    slicingWord = slicingWord.substr(0, lastSpaceIndex);
  }

  return slicingWord + "...";
};
